module.exports = __webpack_public_path__ + "img/05.363cda8c.jpg";